import React from 'react';
import { Box, Text } from '@medely/ui-kit';
import { ContentLoader, PageLayout, PageLayoutContent } from '@mp/components';
import { ShiftSwapReviewItem } from './ShiftSwapReviewItem';
import { useCurrentUser } from '@mp/hooks';
import { useShiftSwaps } from './graphql';
import { useProNavigate } from '@mp/contexts';

export const ShiftSwaps = () => {
  const { currentUser, isLoading: isUserLoading } = useCurrentUser();
  const { shiftRequests, isLoading } = useShiftSwaps({ accountId: currentUser?.id });
  const { navigate } = useProNavigate();

  const shiftRequestsCount = shiftRequests?.length ?? 0;

  const hasNoShiftRequests = !isLoading && shiftRequestsCount === 0;

  const handleAfterMutation = () => {
    if (shiftRequestsCount === 1) {
      navigate('Today');
    }
  };

  return (
    <PageLayout
      handleBack={() => navigate('Today')}
      backButtonText="Back"
      title={currentUser?.company?.name}
    >
      <ContentLoader loading={isLoading || isUserLoading}>
        <PageLayoutContent>
          {hasNoShiftRequests ? (
            <Text size="m">No shift swap requests available.</Text>
          ) : (
            <Box px={4}>
              {shiftRequests?.map((shiftRequest) => (
                <ShiftSwapReviewItem
                  key={shiftRequest.id}
                  job={shiftRequest.job}
                  shiftRequestId={shiftRequest.id}
                  onAfterMutation={handleAfterMutation}
                />
              ))}
            </Box>
          )}
        </PageLayoutContent>
      </ContentLoader>
    </PageLayout>
  );
};
